<div class="scoring-pattern p-2 flex flex-col gap-8">
  <div class="scoring-pattern-header flex justify-between items-center">
    <div class="scoring-pattern-header-title">
      Scoring Information - Test ID : {{ testId }}
    </div>
    <div
      class="scoring-pattern-header-previous-test-holder flex gap-4 items-center"
    >
      <div class="scoring-pattern-header-previous-test-title">
        Select from Previous Test
      </div>
      <div class="scoring-pattern-header-previous-test-select-holder">
        <mat-select
          placeholder="Select a test"
          [(value)]="previousTestId"
          (selectionChange)="getTestScoringPattern(true)"
          class="scoring-pattern-header-previous-test-select"
        >
          <mat-option
            *ngFor="let previousTest of previousTestList"
            [value]="previousTest.testId"
            >{{ previousTest.testCode }}</mat-option
          >
        </mat-select>
        <!-- <p-progressSpinner
          styleClass="w-4rem h-4rem"
          strokeWidth="8"
        ></p-progressSpinner> -->
      </div>
    </div>
  </div>
  <div *ngIf="isDataLoading" class="flex justify-center">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div *ngIf="!isDataLoading" class="scoring-pattern-tables-holder">
    <div class="scoring-pattern-tables flex justify-around">
      <div
        *ngFor="
          let module of moduleList.sectionScoreDetails;
          let moduleIndex = index
        "
        class=""
      >
        <div class="scoring-pattern-tables-table-titles">
          <div class="scoring-pattern-tables-table-titles-title text-center">
            {{ module.moduleName }}
          </div>
          <div
            class="scoring-pattern-tables-table-titles-subtitles flex text-center"
          >
            <div class="scoring-pattern-tables-table-titles-subtitles-subtitle">
              Correct Answers
            </div>
            <div class="scoring-pattern-tables-table-titles-subtitles-subtitle">
              Score
            </div>
          </div>
        </div>
        <div
          *ngIf="formControlsPrepared"
          class="scoring-pattern-tables-table-values-holder"
          [formGroup]="scoringPatternForm"
        >
          <div
            *ngFor="
              let answerAndScore of module.scoreDetails;
              let answerAndScoreIndex = index
            "
            class="scoring-pattern-tables-table-values-collective flex"
          >
            <div class="scoring-pattern-tables-table-values-value">
              {{ answerAndScore.rawScore }}
            </div>
            <div class="scoring-pattern-tables-table-values-value">
              <input
                class="scoring-pattern-tables-table-values-value-input"
                [value]="
                  answerAndScore.score > 0 ||
                  (answerAndScore.rawScore === 0 &&
                    previousTestId !== testId) ||
                  answerAndScore.tscId !== null
                    ? answerAndScore.score
                    : ''
                "
                [formControlName]="
                  module.moduleName! + '-' + answerAndScoreIndex
                "
                [ngClass]="{
                  'scoring-pattern-tables-table-values-value-input-error':
                    getFormControl(module.moduleName!, answerAndScoreIndex)
                      .invalid
                }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-end">
    <span
      class="scoring-pattern-footer-buttons-save"
      [ngClass]="{
        'scoring-pattern-footer-buttons-save-invalid':
          this.scoringPatternForm.invalid || !isSaveAllowed || isBeingSaved
      }"
      (click)="makeSaveStruct()"
    >
      Save
    </span>
  </div>
</div>
<p-dialog
  [(visible)]="isBeingSaved"
  [modal]="true"
  [blockScroll]="true"
  [closeOnEscape]="true"
  [closable]="true"
  [showHeader]="false"
  appendTo="body"
  contentStyleClass="loader flex justify-center"
  styleClass="loaderContainer"
>
  <!-- <mat-spinner>Please wait</mat-spinner> -->
  <p-progressSpinner strokeWidth="4"></p-progressSpinner>
</p-dialog>
